<div *ngIf="showGoTopArrow" class="go-top-arrow cursor-pointer" (click)="goToTopOfPage()">
    <app-icon glyph name="go-top-arrow"></app-icon>
</div>

<div class="content pb-0 px-0">
    <div class="content">
        <div class="header-background row px-5 py-2 mx-0">
            <div class="header-icons-list text-white">
                <div class="pt-1 d-flex justify-content-md-start justify-content-center">
                    <span class="text-size-32 mt-1 d-flex text-md-left text-center main-title">SPORTY'S PILOT TRAINING
                        COURSES</span>
                </div>
                <div class="pt-2">
                    <span class="text-size-18 font-weight-light w-100 text-md-left text-center">Modern flight training
                        for modern pilots</span>
                </div>
                <div class="d-md-block d-none text-white w-100">
                    <div class="d-md-flex d-none justify-content-between text-white header-icons-wrapper">
                        <hr class="col-12 my-2 d-md-block d-none color-white mt-1 pt-1 header-divider">
                        <div class="d-flex justify-content-between w-100">
                            <app-banner-icon backgroundImageUrl="https://dl.videos.sportys.com/onlinecourse/images/discover_devices.svg" description="Nine formats, one price" color="gray"/>
                            <app-banner-icon backgroundImageUrl="https://dl.videos.sportys.com/onlinecourse/images/discover_certificate.svg" description="Automatic written test endorsement" color="gray" />
                            <app-banner-icon backgroundImageUrl="https://dl.videos.sportys.com/onlinecourse/images/discover_play.svg" description="Dynamic in-flight video" color="gray" />
                            <app-banner-icon backgroundImageUrl="https://dl.videos.sportys.com/onlinecourse/images/discover_updates.svg" description="FREE lifetime updates" color="gray" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="body-content-gray body-content">
        <!-- Pilot Training Section -->
      <div class="row pb-md-2 pb-md-0 pb-2 pl-3 pl-md-4 pl-lg-0 mw-100">
        <div class="col pl-lg-2 ml-3 pl-0">
            <div id="titlePilot" class="text-dark text-size-20 font-weight-600">PILOT TRAINING</div>
        </div>
      </div>

      <app-discover-courses class="d-none d-md-flex justify-content-center" [showScrollbar]="false" [courses]="pilotTrainingCourses" [user]="user">
      </app-discover-courses>
      <app-discover-courses class="d-block d-md-none ml-2" [showScrollbar]="true" [courses]="pilotTrainingCourses" [user]="user">
      </app-discover-courses>
      <hr class="d-flex color-secondary-dark my-0 py-0 w-100">

      <!-- Pilot Workshops Section -->
      <ng-template [ngIf]="pilotWorkshopsCourses && pilotWorkshopsCourses.length > 0">
        <div class="row pb-md-2 pb-md-0 pb-2 pl-3 pl-md-4 pl-lg-0 mw-100">
            <div class="col pl-lg-2 ml-2 pl-0 pt-3">
                <div id="titleCurrent" class="text-dark text-size-20 font-weight-600">PILOTWORKSHOPS</div>
            </div>
        </div>

        <app-discover-courses class="d-none d-md-flex justify-content-center" [showScrollbar]="false" [courses]="pilotWorkshopsCourses" [user]="user">
        </app-discover-courses>
        <app-discover-courses class="d-block d-md-none ml-2" [showScrollbar]="true" [courses]="pilotWorkshopsCourses" [user]="user">
        </app-discover-courses>
      </ng-template>
    </div>

    <div class="content" *ngIf="pilotWorkshopsCourses?.length > 0">
        <app-ifr-vfr-mastery-banner/>
    </div>

    <div class="body-content-gray body-content">
      <!-- Get Current Section -->
      <div class="row pb-md-2 pb-md-0 pb-2 pl-3 pl-md-4 pl-lg-0 mw-100">
          <div class="col pl-lg-2 ml-2 pl-0 pt-3">
              <div id="titleCurrent" class="text-dark text-size-20 font-weight-600">GET CURRENT</div>
          </div>
      </div>
      <app-discover-courses class="d-none d-md-flex justify-content-center" [showScrollbar]="false" [courses]="getCurrentCourses" [user]="user">
      </app-discover-courses>
      <app-discover-courses class="d-block d-md-none ml-2" [showScrollbar]="true" [courses]="getCurrentCourses" [user]="user">
      </app-discover-courses>
    </div>

    <div class="content">
        <app-pilot-training-banner/>
    </div>

    <div class="body-content-gray body-content mt-4">
        <!-- Aircraft Transitions Section -->
        <div class="row pb-md-2 pb-md-0 pb-2 pl-3 pl-md-4 pl-lg-0 mw-100">
            <div class="col pl-lg-2 ml-3 pl-0">
                <div id="titleAircraft" class="text-dark text-size-20 font-weight-600">AIRCRAFT TRANSITIONS</div>
            </div>
        </div>
        <app-discover-courses class="d-none d-md-flex justify-content-center" [showScrollbar]="false" [fitContent]="true" [user]="user"
            [courses]="aircraftTransitionsCourses"></app-discover-courses>
        <app-discover-courses class="d-block d-md-none ml-2" [showScrollbar]="true" [fitContent]="true" [user]="user"
            [courses]="aircraftTransitionsCourses"></app-discover-courses>
        <hr class="d-flex color-secondary-dark my-0 py-0 w-100">

        <!-- Avionics Section -->
        <div class="row pb-md-2 pb-md-0 pb-2 pl-3 pl-md-4 pl-lg-0 mw-100">
            <div class="col pl-lg-2 ml-2 pl-0 pt-3">
                <div id="titleAvionics" class="text-dark text-size-20 font-weight-600">AVIONICS</div>
            </div>
        </div>
        <app-discover-courses class="d-none d-md-flex justify-content-center" [showScrollbar]="false" [fitContent]="true" [user]="user"
            [courses]="avionicsCourses"></app-discover-courses>
        <app-discover-courses class="d-block d-md-none ml-2" [showScrollbar]="true" [fitContent]="true" [user]="user"
            [courses]="avionicsCourses"></app-discover-courses>
        <hr class="d-flex color-secondary-dark my-0 py-0 w-100">

        <!-- Garmin E-Learning Section -->
        <div class="row pb-md-2 pb-md-0 pb-2 pl-3 pl-md-4 pl-lg-0 mw-100">
            <div class="col pl-lg-2 ml-2 pl-0 pt-3">
                <div id="titleGarmin" class="text-dark text-size-20 font-weight-600">GARMIN ELEARNING</div>
            </div>
        </div>

        <app-discover-courses class="d-none d-md-flex justify-content-center" [showScrollbar]="false" [fitContent]="true" [user]="user"
            [courses]="garminElearningCourses"></app-discover-courses>
        <app-discover-courses class="d-block d-md-none ml-2" [showScrollbar]="true" [fitContent]="true" [user]="user"
            [courses]="garminElearningCourses"></app-discover-courses>
        <hr class="d-flex color-secondary-dark my-0 py-0 w-100">
    </div>

</div>
